<template>
  <section>
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto">
          <v-btn class="accent shadow-4 px-8" large rounded @click="isFormOpen = true">
            Añadir Responsable
          </v-btn>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="tableList"
        :options.sync="tableOptions"
        :search="search"
        :loading="isLoading"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleClickEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleClickDelete(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <responsible-dialog :open="isFormOpen" :editData="itemToEdit" @dialog:close="closeForm"></responsible-dialog>
    <core-delete-dialog
      :open="isDeleteOpen"
      :onDelete="deleteItem"
      title="especialidad"
      @dialog:close="closeDeleteDialog"
    ></core-delete-dialog>
  </section>
</template>

<script>
import ResponsibleDialog from "@/components/Appointments/ResponsibleDialog.vue";
import { PbxHttpClient } from "@/services/httpclient";
import CoreDeleteDialog from "@/components/Utils/CoreDeleteDialog.vue";

export default {
  components: { ResponsibleDialog, CoreDeleteDialog },
  data() {
    return {
      isLoading: false,
      isFormOpen: false,
      isDeleteOpen: false,
      search: "",
      headers: [
        {
          text: "Nombres",
          value: "name",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Apellidos",
          value: "last_name",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "DNI",
          value: "dni",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Correo",
          value: "email",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Telefono",
          value: "phone",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "10%",
          align: "right",
          sortable: false,
        },
      ],
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      tableList: [],
      totalItems: 0,
      itemToEdit: null,
    };
  },

  watch: {
    tableOptions: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const { sortDesc, page, itemsPerPage } = this.tableOptions;

        const { data } = await PbxHttpClient.get("/module_appointment/responsibles", {
          params: { page, itemPerPage: itemsPerPage, prioritySort: sortDesc },
        });
        this.tableList = data.data;
        this.totalItems = data.total;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },

    closeForm(item = false) {
      this.isFormOpen = false;
      if (item) {
        if (this.itemToEdit) this.tableList = this.tableList.map((el) => (el.id === item.id ? item : el));
        else this.tableList = [...this.tableList, item];
      }
      this.itemToEdit = null;
    },
    closeDeleteDialog() {
      this.itemToEdit = null;
      this.isDeleteOpen = false;
    },

    handleClickEdit(item) {
      this.itemToEdit = item;
      this.isFormOpen = true;
    },
    handleClickDelete(item) {
      this.itemToEdit = item;
      this.isDeleteOpen = true;
    },

    async deleteItem() {
      try {
        await PbxHttpClient.delete(`/module_appointment/responsibles/${this.itemToEdit.id}`);
        this.$snotify.success("Responsable eliminada con exito", "¡Hecho!");
        this.tableList = this.tableList.filter((el) => el.id !== this.itemToEdit.id);
        return true;
      } catch (error) {
        this.$snotify.error("Hubo un error eliminando la Responsable", "¡Error!");
        console.log("error deleting appointment", error);
        return false;
      }
    },
  },
};
</script>
